"use client";

import {
	MARKETING_NAV_SHELL_BG_CLASS,
	MARKETING_SITE_HEADER_HEIGHT_VAR,
	MARKETING_SITE_HEADER_SHADOW_CLASS,
	MARKETING_SITE_HEADER_STACK_Z_CLASS,
} from "@marketing/shared/lib/marketing-layout-vars";
import { cn } from "@repo/ui";
import { ConnectivityBanner } from "@saas/shared/components/connectivity/ConnectivityBanner";
import { MarketingBanner } from "@shared/components/marketing-banner";
import * as React from "react";
import { NavBar } from "./NavBar";

export function MarketingSiteHeader() {
	const headerRef = React.useRef<HTMLElement>(null);

	React.useLayoutEffect(() => {
		const el = headerRef.current;
		if (!el || typeof document === "undefined") {
			return;
		}

		const sync = () => {
			const px = Math.ceil(el.getBoundingClientRect().height);
			document.documentElement.style.setProperty(
				MARKETING_SITE_HEADER_HEIGHT_VAR,
				`${px}px`,
			);
			// Shared “site header height” for any full-viewport surfaces (marketing + saas).
			document.documentElement.style.setProperty(
				"--sq-site-header-height",
				`${px}px`,
			);
		};

		sync();

		const ro = new ResizeObserver(sync);
		ro.observe(el);
		window.addEventListener("resize", sync);

		return () => {
			ro.disconnect();
			window.removeEventListener("resize", sync);
			document.documentElement.style.removeProperty(
				MARKETING_SITE_HEADER_HEIGHT_VAR,
			);
			document.documentElement.style.removeProperty(
				"--sq-site-header-height",
			);
		};
	}, []);

	return (
		<header
			ref={headerRef}
			className={cn(
				"sticky top-0",
				MARKETING_SITE_HEADER_SHADOW_CLASS,
				MARKETING_SITE_HEADER_STACK_Z_CLASS,
				MARKETING_NAV_SHELL_BG_CLASS,
			)}
			data-marketing-site-header
		>
			<ConnectivityBanner embedded />
			<MarketingBanner />
			<NavBar underStickyMarketingHeader />
		</header>
	);
}
